import React from 'react';
import {
  apiRequest,
  apiRequestNoLoadder
  , apiBatchRequest
} from '../../utils/api_service';
import { API_URL, createApiUrl } from '../../constants/api';
import RenderInlineForm from './RenderInlineForm';
import RenderChart from '../common/Chart/RenderChart';
import moment from 'moment';
import DownloadIcon from '@material-ui/icons/CloudDownloadOutlined';
import ViewIcon from '@material-ui/icons/VisibilityOutlined';

import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import MoreVertOutlined from '@material-ui/icons/MoreVertOutlined';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import { ListItemSecondaryAction } from '@material-ui/core';
import DenseTable from './RenderTable';
import RenderKeyValueForm from './RenderKeyValueForm';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import camelcaseKeys from 'camelcase-keys';
import PropTypes from 'prop-types';
import Workbook from 'react-excel-workbook';

// import { NavLink } from 'react-router-dom';
import {
  GetKeyValueData,
  GetPropsForData,
  GetChartData
} from '../../utils/graph_service';

import Skeleton from '@material-ui/lab/Skeleton';
import {
  PaperComponent,
  buildWidgetUrlWithParameter,
  UpdateColumnWithConfiguration,
  IsSectionVisible
} from '../../utils/helper';
import _ from 'lodash';
import store from '../../store/appStore';
import { getFormattedValues } from '../../utils/formatData';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { withRouter } from 'react-router-dom';
import { SECTIONS } from '../../constants/appConstants';
// const DefaultColors = [
//   '#D14040',
//   '#7F40D1',
//   '#2D76E5',
//   '#1BBC86',
//   '#E2E22D',
//   '#92661A',
//   '#EB9563',
//   '#E5897F',
//   '#E24E89',
//   '#C063E8',
//   '#63B3E8'
// ];

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

class RenderLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      responseData: undefined,
      openMenu: false,
      anchorEl: null,
      openAddWidgetPanel: false,
      openViewDetailsPanel: false,
      selectedTabvalue: 0,
      layoutComponent: {
        data: [],
        component: <></>
      },
      drillDownConfig: {
        isDrillDown: false,
        config: [
          {
            key: '',
            type: 'YTD',
            accessor: '',
            level: 1,
            seriesItem: {}
          }
        ],
        currentLevel: 1
      },
      parentId: this.props.parentId,
      isDesktop: this.props.isDesktop,
      layoutConfig: this.props.layoutConfig,
      onDemandStartDate: this.props.startDate,
      onDemandEndDate: this.props.endDate
    };
  }

  componentDidMount() {
    this.GetData(
      this.props.startDate,
      this.props.endDate,
      this.props.widgetconfig
    );
  }

  componentWillReceiveProps(newProps) {
    if (
      newProps.startDate !== this.props.startDate ||
      newProps.endDate !== this.props.endDate ||
      newProps.layoutUpdated !== this.props.layoutUpdated
    ) {
      this.GetData(
        newProps.startDate,
        newProps.endDate,
        newProps.widgetconfig
      );
    }
  }

  GetData = (startDate, endDate, widgetconfig, forComparrision) => {
    this.setState({
      responseData: undefined
    });
    if (widgetconfig.isForPerformance === true) {
      this.GetPerformanceData(
        startDate,
        endDate,
        widgetconfig,
        forComparrision
      );
    } else {
      const configuration = this.getConfiguration(widgetconfig);
      if (((configuration || {}).trend || {}).type === 'YTD') {
        startDate = moment(startDate).subtract(12, 'months').format('MM/DD/YYYY');
      }
      const arg = [{ key: 'startDate', value: startDate }, { key: 'endDate', value: endDate }];
      // if (widgetconfig.widgetId === 9 && configuration.showDetailsOndemand) {
      if (configuration.showDetailsOndemand) {
        localStorage.removeItem(widgetconfig.widgetId + 'selectedConfig');
        const selected = { startDate: startDate, endDate: endDate, marketName: null };
        localStorage.setItem(widgetconfig.widgetId + 'selectedConfig', JSON.stringify(selected));
      }
      apiRequestNoLoadder({
        url: createApiUrl(buildWidgetUrlWithParameter(widgetconfig.dataUrl, arg)),
        // postBody: [],
        key: 'response',
        fromCache: widgetconfig.widgetType !== 10
      }).then((response) => {
        const burdenRate = [];
        // const departmentName = [];
        if ((widgetconfig.dataUrl).includes('Market')) {
          burdenRate.push('burdenRate');
        }
        // if ((widgetconfig.dataUrl).includes('Property')) {
        //   departmentName.push('departmentName');
        // }
        this.setState({
          ignoreColumns: response.ignoreColumns || ['rateValue', 'statusName', 'isApproved', 'employeeStatus', 'calenderMonth', 'calenderDay', 'category', 'percentAllocation', 'totalEmployeeCount', ...burdenRate],
          responseData: configuration.showDetailsOndemand ? response : response.data,
          rawData: response.rawData,
          layoutComponent: this.getWidgetLayout(
            widgetconfig,
            response.data,
            false
          ),
          tableConfig: response.config
        });
      });
    }
  };

  GetPerformanceData = (
    startDate,
    endDate,
    widgetconfig,
    forComparrision
  ) => {
    const params = {
      startDate: startDate,
      endDate: endDate,
      reportId: widgetconfig.reportId,
      type:
        moment(startDate).format('YYYY') === moment(endDate).format('YYYY') &&
          moment(startDate).format('MM') === moment(endDate).format('MM')
          ? 'Month'
          : 'YTD',
      isCalenderView: false,
      selectedAttribute: widgetconfig.attributeId.toString()
    };
    apiRequest({
      url: API_URL.reports.PerformanceTrendByDate,
      params: params
    }).then(response => {
      const result = response.data;
      this.setState({
        responseData: result,
        ignoreColumns: response.ignoreColumns || [],
        layoutComponent: this.getWidgetLayout(
          widgetconfig,
          result,
          false
        ),
        ComparisonstartDate: startDate,
        ComparisonEndDate: endDate
      });
    });
  };

  handleClick = event => {
    this.getViewDownloadData();
    this.setState({ anchorEl: event.currentTarget, openMenu: true });
  };

  handleClose = () => {
    this.setState({ anchorEl: null, openMenu: false });
  };

  getWidgetLayout = (
    widgetconfig,
    responseData,
    onlyData = false
  ) => {
    const startDate =
      this.state.openComparisonDetailsPanel === true
        ? this.state.ComparisonstartDate
        : this.props.startDate;
    const endDate =
      this.state.openComparisonDetailsPanel === true
        ? this.state.ComparisonEndDate
        : this.props.endDate;

    if (widgetconfig.isConfigurable || widgetconfig.isForPerformance) {
      const configuration = this.getConfiguration(widgetconfig);
      let data = [];

      if (widgetconfig.widgetType === 10) {
        return {
          data: responseData,
          component: (this.getPendingApprovalProcessWidget(responseData || [])
          )
        };
      }
      // 1: inline Form
      if (widgetconfig.widgetType === 1) {
        data = GetKeyValueData(responseData, configuration, true, true, widgetconfig);
        if (onlyData === true) return data;
        return {
          data: data,
          isKeyValue: true,
          component: (
            <RenderKeyValueForm
              data={data}
              identifier={
                'Child_layout' +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && 'preview')
              }
              key={
                'Child_layout' +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && 'preview')
              }
            ></RenderKeyValueForm>
          )
        };
      }

      // 2: Key Value Form
      if (widgetconfig.widgetType === 2) {
        data = GetKeyValueData(responseData, configuration, true, true, widgetconfig);
        if (onlyData === true) return data;
        return {
          data: data,
          isKeyValue: true,
          component: (
            <RenderInlineForm
              data={data}
              identifier={
                'Child_layout' +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && 'preview')
              }
              key={
                'Child_layout' +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && 'preview')
              }
            ></RenderInlineForm>
          )
        };
      }

      // 3: Table value Chart
      if (widgetconfig.widgetType === 3) {
        if (onlyData === true) return responseData;
        return {
          data: responseData,
          component: (
            <DenseTable
              columns={configuration.columns}
              data={responseData}
              identifier={
                'Child_layout' +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && 'preview')
              }
              key={
                'Child_layout' +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && 'preview')
              }
            ></DenseTable>
          )
        };
      }
      let PerformanceRawData = [];
      if (widgetconfig.isForPerformance) {
        if (responseData.data !== undefined) {
          if (
            responseData.data[0].yAxisLabel !== undefined &&
            responseData.data[0].yAxisLabel !== null
          ) {
            configuration.yAxisLabel = responseData.data[0].yAxisLabel;
          }
        }
        if (
          responseData.data[0].xAxisLabel !== undefined &&
          responseData.data[0].xAxisLabel !== null
        ) {
          configuration.xAxisLabel = responseData.data[0].xAxisLabel;
        }
        PerformanceRawData = responseData.rawData;
        responseData.data = responseData.data[0].data;
      }
      // 4: Multiline Chart
      if (widgetconfig.widgetType === 4) {
        const resData = widgetconfig.isForPerformance
          ? responseData
          : GetChartData(responseData, configuration, startDate, endDate);
        if (onlyData === true) return resData.data;

        return {
          data: resData.data,
          isKeyValue: false,
          accessor: resData.chartAccessor.mainAccessor,
          keys: resData.barKeys,
          unit: resData.unit,
          xAxisLabel: configuration.xAxisLabel,
          component: (
            <RenderChart
              identifier={
                'Child_layout_chart' +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && 'preview')
              }
              key={
                'Child_layout_chart' +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && 'preview')
              }
              legends={resData.legends}
              drillDownConfig={this.state.drillDownConfig}

              allowDrillDown={true}
              chartConfig={{
                widgetId: widgetconfig.widgetId,
                usersWidgetMappingId: widgetconfig.widgetId,
                startDate: startDate,
                endDate: endDate,
                configuration: configuration,
                rawData: widgetconfig.isForPerformance
                  ? PerformanceRawData
                  : responseData,
                data: resData.data,
                yAxisLabel: configuration.yAxisLabel,
                type: 'LineChart',
                multiLineChartAcessors: resData.chartAccessor,
                accessor: resData.chartAccessor.mainAccessor,
                colors: resData.colors,
                unit: resData.unit,
                widgetconfig: widgetconfig,
                xAxisLabel: configuration.xAxisLabel
              }}
            ></RenderChart>
          )
        };
      }

      // 5: Bar Chart

      if (widgetconfig.widgetType === 5) {
        const resData = widgetconfig.isForPerformance
          ? responseData
          : GetKeyValueData(responseData, configuration, true, true, widgetconfig);
        if (onlyData === true) return resData.data;

        return {
          data: resData.data,
          isKeyValue: true,
          isAutoSwitch: resData.isAutoSwitch,
          component: (
            <RenderChart
              identifier={
                'Child_layout_chart' +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && 'preview')
              }
              key={
                'Child_layout_chart' +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && 'preview')
              }
              legends={resData.legends}
              drillDownConfig={this.state.drillDownConfig}

              allowDrillDown={true}
              chartConfig={{
                widgetId: widgetconfig.widgetId,
                usersWidgetMappingId: widgetconfig.widgetId,
                startDate: startDate,
                endDate: endDate,
                configuration: configuration,
                rawData: responseData,
                data: resData.data,
                yAxisLabel: configuration.yAxisLabel,
                type: 'BarChart',
                colors: resData.colors,
                unit: resData.unit,
                widgetconfig: widgetconfig
              }}
            ></RenderChart>
          )
        };
      }

      // 6: Donut Chart
      if (widgetconfig.widgetType === 6) {
        const resData = widgetconfig.isForPerformance
          ? responseData
          : GetKeyValueData(responseData, configuration, true, true, widgetconfig);
        if (onlyData === true) return resData.data;

        return {
          data: resData.data,
          isKeyValue: true,
          isAutoSwitch: resData.isAutoSwitch,
          component: (
            <RenderChart
              identifier={
                'Child_layout_chart' +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && 'preview')
              }
              key={
                'Child_layout_chart' +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && 'preview')
              }
              legends={resData.legends}
              drillDownConfig={this.state.drillDownConfig}

              allowDrillDown={true}
              chartConfig={{
                widgetId: widgetconfig.widgetId,
                usersWidgetMappingId: widgetconfig.widgetId,
                startDate: startDate,
                endDate: endDate,
                configuration: configuration,
                rawData: responseData,
                data: resData.data,
                type: 'DonutChart',
                colors: resData.colors,
                unit: resData.unit,
                widgetconfig: widgetconfig
              }}
            ></RenderChart>
          )
        };
      }

      // 7: Pie Chart
      if (widgetconfig.widgetType === 7) {
        const resData = widgetconfig.isForPerformance
          ? responseData
          : GetKeyValueData(responseData, configuration, true, true, widgetconfig);

        if (onlyData === true) return resData.data;
        return {
          data: resData.data,
          isKeyValue: true,
          isAutoSwitch: resData.isAutoSwitch,
          component: (
            <RenderChart
              identifier={
                'Child_layout_chart' +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && 'preview')
              }
              key={
                'Child_layout_chart' +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && 'preview')
              }
              legends={resData.legends}
              drillDownConfig={this.state.drillDownConfig}

              allowDrillDown={true}
              chartConfig={{
                widgetId: widgetconfig.widgetId,
                usersWidgetMappingId: widgetconfig.widgetId,
                startDate: startDate,
                endDate: endDate,
                configuration: configuration,
                rawData: responseData,
                data: resData.data,
                type: 'PieChart',
                colors: resData.colors,
                unit: resData.unit,
                widgetconfig: widgetconfig
              }}
            ></RenderChart>
          )
        };
      }

      // 8: Stack bar Chart
      if (widgetconfig.widgetType === 8) {
        const resData = widgetconfig.isForPerformance
          ? responseData
          : GetChartData(responseData, configuration, startDate, endDate);
        if (onlyData === true) return resData.data;
        return {
          data: resData.data,
          isKeyValue: false,
          accessor: resData.chartAccessor.mainAccessor,
          keys: resData.barKeys,
          unit: resData.unit,
          xAxisLabel: configuration.xAxisLabel,
          component: (
            <RenderChart
              identifier={
                'Child_layout_chart' +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && 'preview')
              }
              key={
                'Child_layout_chart' +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && 'preview')
              }
              legends={resData.legends}
              drillDownConfig={this.state.drillDownConfig}

              allowDrillDown={true}
              chartConfig={{
                widgetId: widgetconfig.widgetId,
                usersWidgetMappingId: widgetconfig.widgetId,
                startDate: startDate,
                endDate: endDate,
                configuration: configuration,
                rawData: widgetconfig.isForPerformance
                  ? PerformanceRawData
                  : responseData,
                data: resData.data,
                yAxisLabel: configuration.yAxisLabel,
                type: 'StackBarChart',
                keys: resData.barKeys,
                colors: resData.barColors,
                accessor: resData.chartAccessor.mainAccessor,
                unit: resData.unit,
                widgetconfig: widgetconfig,
                xAxisLabel: configuration.xAxisLabel
              }}
            ></RenderChart>
          )
        };
      }

      // 9: Group Bar Chart
      if (widgetconfig.widgetType === 9) {
        const resData = widgetconfig.isForPerformance
          ? responseData
          : GetChartData(responseData, configuration, startDate, endDate);
        if (onlyData === true) return resData.data;
        return {
          data: resData.data,
          isKeyValue: false,
          accessor: resData.chartAccessor.mainAccessor,
          keys: resData.barKeys,
          unit: resData.unit,
          xAxisLabel: configuration.xAxisLabel,
          component: (
            <RenderChart
              identifier={
                'Child_layout_chart' +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && 'preview')
              }
              key={
                'Child_layout_chart' +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && 'preview')
              }
              legends={resData.legends}
              drillDownConfig={this.state.drillDownConfig}

              allowDrillDown={true}
              chartConfig={{
                widgetId: widgetconfig.widgetId,
                usersWidgetMappingId: widgetconfig.widgetId,
                startDate: startDate,
                endDate: endDate,
                configuration: configuration,
                rawData: widgetconfig.isForPerformance
                  ? PerformanceRawData
                  : responseData,
                data: resData.data,
                yAxisLabel: configuration.yAxisLabel,
                type: 'GroupBarChart',
                keys: resData.barKeys,
                colors: resData.barColors,
                accessor: resData.chartAccessor.mainAccessor,
                unit: resData.unit,
                widgetconfig: widgetconfig,
                xAxisLabel: configuration.xAxisLabel
              }}
            ></RenderChart>
          )
        };
      }
    } else {
      if (onlyData === true) return responseData;
      if (widgetconfig.widgetType === 1) {
        return {
          data: responseData,
          isKeyValue: true,
          component: (
            <RenderKeyValueForm
              data={responseData}
              identifier={
                'Child_layout' +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && 'preview')
              }
              key={
                'Child_layout' +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && 'preview')
              }
            ></RenderKeyValueForm>
          )
        };
      }
      if (widgetconfig.widgetType === 2) {
        return {
          data: responseData,
          isKeyValue: true,
          component: (
            <RenderInlineForm
              data={responseData}
              identifier={
                'Child_layout' +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && 'preview')
              }
              key={
                'Child_layout' +
                widgetconfig.usersWidgetMappingId +
                widgetconfig.widgetType +
                (this.props.IsInPreviewMode && 'preview')
              }
            ></RenderInlineForm>
          )
        };
      }
      if (widgetconfig.widgetType === 10) {
        return {
          data: responseData,
          component: (this.getPendingApprovalProcessWidget(responseData || [])
          )
        };
      }
    }
    return {
      data: [],
      component: <></>
    };
  };

  getPendingApprovalProcessWidget = (pendingActionsData = []) => {
    return (<>
      <div className="row">
        <div className="col-sm-12 widget-container">
          <div className="row ">
            <div className="col-sm-12 inner-container center-sm">
              {/* Actions pending for approvals */}
              <div className="center-sm inner-container-small">Group: {(((((store.getState() || {}).user || {}).userData || {}).groups || [])[0] || {}).configurationName || ''}</div>
              {/* <NavLink to={'/pendingRequests'} style={{ color: '#FFF', fontSize: 'small' }}>
              View All Pending Requests
            </NavLink> */}
            </div>
          </div>

          <List style={{ width: '100%' }}>
            {pendingActionsData.length > 0
              ? pendingActionsData.map((value, index) => (
                <>
                  <ListItem alignItems="flex-start">
                    <ListItemText className="approval-text" primary={value.categoryDescription}
                      secondary={<React.Fragment>{value.approvalStatus}</React.Fragment>} />
                    <ListItemSecondaryAction>

                      {IsSectionVisible(SECTIONS.DASHBOARD, SECTIONS.PENDING_ACTION) && <div className="link-click" onClick={(e) => this.viewPendingRequest(e, value)}>
                        View
                      </div>}

                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider component="li" />
                </>
              ))
              : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAnchor: 'middle', fontFamily: 'roboto', fontSize: '0.86em', fontWeight: '500', marginTop: '8rem' }}></div>}
          </List>
        </div>

      </div>
      {pendingActionsData.length <= 0 && <div style={{ width: '100%', paddingLeft: '36%', height: '100%' }}><span>No Items for approval.</span>
      </div>}
    </>
    );
  }

  // viewPendingRequest = (row) => {
  //   window.open(window.location.origin + '/pendingRequests?recordId=' + row.recordId + '&category=' + row.category + '&recordIdType=' + row.recordIdType, '_self');
  // }

  viewPendingRequest = (event, row) => {
    event.preventDefault();

    // window.open(window.location.origin + '/pendingRequests?recordId=' + row.recordId + '&category=' + row.category + '&recordIdType=' + row.recordIdType, '_self');

    this.props.history.push('/pendingRequests?recordId=' + row.recordId + '&category=' + row.category + '&recordIdType=' + row.recordIdType + '&modifiedBy=' + row.modifiedBy + '&modifiedOn=' + row.modifiedOn);
  }

  totalCount = (array, key) => {
    return array.reduce((r, a) => {
      return r + a[key];
    }, 0);
  };

  viewData = async () => {
    const { widgetconfig } = this.props;
    let sDate, eDate;
    const configuration = JSON.parse(widgetconfig.configuration);
    // let layoutdata = localStorage.getItem(widgetconfig.widgetId);
    // let config = localStorage.getItem(widgetconfig.widgetId + 'drillconfig');

    let layoutdata = (((store.getState() || {}).localCache || {}).cachedData || []).find(x => x.key === widgetconfig.widgetId)?.data;
    let config = (((store.getState() || {}).localCache || {}).cachedData || [])
      .find(x => x.key === widgetconfig.widgetId + 'drillconfig')?.data;

    let responseData;
    if (layoutdata && layoutdata !== '' && layoutdata.length > 0 && layoutdata !== 'undefined') {
      // layoutdata = JSON.parse(layoutdata);
    } else {
      layoutdata = this.state.layoutComponent?.data;
    }
    if (config && config !== '') {
      config = config;

      // if (widgetconfig.widgetId === 9 && configuration.showDetailsOndemand) {
      if (configuration.showDetailsOndemand) {
        const level = config?.currentLevel;
        let key = level !== undefined ? config?.config[level - 1].key : '';
        if (level > 1) {
          key = configuration.drillDownConfig ? configuration.drillDownConfig[configuration.drillDownConfig.length - 2].key : '';
        }

        const dataUrl = widgetconfig.dataUrl;// + '&showDetail=true';
        let selectedConfig = localStorage.getItem(widgetconfig.widgetId + 'selectedConfig');
        if (selectedConfig && selectedConfig !== '' && selectedConfig.length > 0 && selectedConfig !== undefined) {
          selectedConfig = JSON.parse(selectedConfig);
        }
        if (level === 1) {
          sDate = this.props.startDate;
          sDate = moment(sDate).subtract(12, 'months').format('MM/DD/YYYY');
          eDate = this.props.endDate;
          responseData = await this.getOnDemandData(dataUrl, sDate, eDate, selectedConfig.marketName, key);
        } else {
          sDate = selectedConfig.startDate;
          eDate = selectedConfig.endDate;
          responseData = await this.getOnDemandData(dataUrl, selectedConfig.startDate, selectedConfig.endDate, selectedConfig.marketName, key);
        }
      }
    }
    // if (widgetconfig.widgetId === 9 && configuration.showDetailsOndemand) {
    if (configuration.showDetailsOndemand) {
      this.setState({ openViewDetailsPanel: !this.state.openViewDetailsPanel, responseData: responseData, onDemandStartDate: sDate, onDemandEndDate: eDate });
    } else {
      this.setState({ openViewDetailsPanel: !this.state.openViewDetailsPanel });
    }
    if (this.props.stopDrag) {
      this.props.stopDrag(!this.state.openViewDetailsPanel, this.props.layoutConfig);
    }
  };

  getViewDownloadData = async () => {
    const { widgetconfig } = this.props;
    let sDate, eDate;
    const configuration = JSON.parse(widgetconfig.configuration);

    let layoutdata = (((store.getState() || {}).localCache || {}).cachedData || []).find(x => x.key === widgetconfig.widgetId)?.data;
    let config = (((store.getState() || {}).localCache || {}).cachedData || [])
      .find(x => x.key === widgetconfig.widgetId + 'drillconfig')?.data;

    let responseData;
    if (layoutdata && layoutdata !== '' && layoutdata.length > 0 && layoutdata !== 'undefined') {
    } else {
      layoutdata = this.state.layoutComponent?.data;
    }
    if (config && config !== '') {
      config = config;
      if (configuration.showDetailsOndemand) {
        const level = config?.currentLevel;
        let key = level !== undefined ? config?.config[level - 1].key : '';
        if (level > 1) {
          key = configuration.drillDownConfig ? configuration.drillDownConfig[configuration.drillDownConfig.length - 2].key : '';
        }

        const dataUrl = widgetconfig.dataUrl;// + '&showDetail=true';
        let selectedConfig = localStorage.getItem(widgetconfig.widgetId + 'selectedConfig');
        if (selectedConfig && selectedConfig !== '' && selectedConfig.length > 0 && selectedConfig !== undefined) {
          selectedConfig = JSON.parse(selectedConfig);
        }
        if (level === 1) {
          sDate = this.props.startDate;
          sDate = moment(sDate).subtract(12, 'months').format('MM/DD/YYYY');
          eDate = this.props.endDate;
          responseData = await this.getOnDemandData(dataUrl, sDate, eDate, selectedConfig.marketName, key);
        } else {
          sDate = selectedConfig.startDate;
          eDate = selectedConfig.endDate;
          responseData = await this.getOnDemandData(dataUrl, selectedConfig.startDate, selectedConfig.endDate, selectedConfig.marketName, key);
        }
        this.setState({ responseData: responseData, onDemandStartDate: sDate, onDemandEndDate: eDate });
      }
    }
  }

  tabProps = index => {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`
    };
  };

  handleTabChange = (event, newValue) => {
    this.setState({ selectedTabvalue: newValue });
  };

  handleTabChangeIndex = index => {
    this.setState({ selectedTabvalue: newValue });
  };

  DownloadOnDemandData = async (responseData, widgetconfig) => {
    const config = this.getConfiguration(widgetconfig);
    const configuration = JSON.parse(widgetconfig.configuration);
    if (configuration.showDetailsOndemand) {
      const level = config?.currentLevel;
      let key = level !== undefined ? config?.config[level - 1].key : '';
      if (level > 1) {
        key = configuration.drillDownConfig ? configuration.drillDownConfig[configuration.drillDownConfig.length - 2].key : '';
      }

      const dataUrl = widgetconfig.dataUrl;// + '&showDetail=true';
      let selectedConfig = localStorage.getItem(widgetconfig.widgetId + 'selectedConfig');
      if (selectedConfig && selectedConfig !== '' && selectedConfig.length > 0 && selectedConfig !== undefined) {
        selectedConfig = JSON.parse(selectedConfig);
      }
      responseData = await this.getOnDemandData(dataUrl, selectedConfig.startDate, selectedConfig.endDate, selectedConfig.marketName, key);
      responseData = responseData.rawData !== undefined ? responseData.rawData : responseData;
      this.DownloadData(responseData, widgetconfig);
    } else {
      this.DownloadData(responseData, widgetconfig);
    }
  }

  DownloadData = (responseData, widgetconfig) => {
    let { ignoreColumns, tableConfig } = this.state;
    const config = this.getConfiguration(widgetconfig);
    // let layoutdata = localStorage.getItem(widgetconfig.widgetId);
    let layoutdata = (((store.getState() || {}).localCache || {}).cachedData || []).find(x => x.key === widgetconfig.widgetId)?.data;

    if (layoutdata && layoutdata !== '' && layoutdata.length > 0 && layoutdata !== 'undefined') {
      layoutdata = (layoutdata);
    } else {
      layoutdata = this.state.layoutComponent?.data;
    }

    if (config && config.ignoreColumns) {
      const configIgnoreColumn = config.ignoreColumns.split(',');
      if (configIgnoreColumn) {
        if (ignoreColumns === undefined) {
          ignoreColumns = configIgnoreColumn;
        } else {
          ignoreColumns = [...ignoreColumns, ...configIgnoreColumn];
        }
      }
    }

    const propsSheet1 = GetPropsForData(
      'summary',
      responseData,
      widgetconfig,
      layoutdata
    );
    const propsSheet2 = GetPropsForData(
      'Details',
      widgetconfig.isForPerformance === true
        ? responseData.rawData
        : widgetconfig.isConfigurable === false && widgetconfig.widgetType !== 10
          ? this.state.rawData
          : responseData,
      widgetconfig,
      layoutdata
    );

    propsSheet1.columns = UpdateColumnWithConfiguration(
      propsSheet1.columns,
      tableConfig || []
    );

    propsSheet1.columns = propsSheet1.columns.filter(
      ar =>
        (ignoreColumns || []).find(rm => _.camelCase(rm) === _.camelCase(ar.key)) === undefined &&
        _.camelCase(ar.key) !== _.camelCase('data') && ar.isVisible !== false && ar.key !== 'keyTitle' &&
        ar.key !== 'drillDownKey' &&
        ar.key !== 'isAutoSwitch'
    );

    (propsSheet1.data || []).forEach(x => {
      propsSheet1.columns.forEach((column, index) => {
        // const value = x[column.key] = getFormattedValues(x[column.key], column.dataFormat, true);
        // x[column.key] = formatExcelData(column.dataFormat, value);
        x[column.key] = getFormattedValues(x[column.key], column.dataFormat, true);
      });
    });

    propsSheet2.columns = UpdateColumnWithConfiguration(
      propsSheet2.columns,
      tableConfig || []
    );
    propsSheet2.columns = propsSheet2.columns.filter(
      ar =>
        (ignoreColumns || []).find(rm => _.camelCase(rm) === _.camelCase(ar.key)) === undefined &&
        _.camelCase(ar.key) !== _.camelCase('data') &&
        _.camelCase(ar.key).includes('Id', ar.key.length - 2) !== true && ar.isVisible !== false && ar.key !== 'keyTitle' &&
        ar.key !== 'drillDownKey' &&
        ar.key !== 'isAutoSwitch'
    );
    (propsSheet2.data || []).forEach(x => {
      propsSheet2.columns.forEach((column, index) => {
        x[column.key] = getFormattedValues(x[column.key], column.dataFormat, true);
      });
    });
    return (
      <Workbook
        filename={
          widgetconfig.title +
          ' from ' +
          (config.showDetailsOndemand ? this.state.onDemandStartDate?.replace('/', '_') : this.props.startDate?.replace('/', '_')) +
          ' to ' +
          (config.showDetailsOndemand ? this.state.onDemandEndDate?.replace('/', '_') : this.props.endDate?.replace('/', '_')) +
          '_data.xlsx'
        }
        element={
          <ListItem
            button
            divider
            onClick={() => {
              this.handleClose();
            }}
          >
            <ListItemIcon>
              {' '}
              <DownloadIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Download Data" />
          </ListItem>
        }
      >
        <Workbook.Sheet data={propsSheet1.data} name="summary">
          {propsSheet1.columns.map((column, index) => (
            <Workbook.Column key={column.name} label={column.name} value={column.key} />
          ))}
        </Workbook.Sheet>
        <Workbook.Sheet data={propsSheet2.data} name="Detail sheet">
          {propsSheet2.columns.map((column, index) => (
            <Workbook.Column key={column.name} label={column.uiColumn || column.name} value={column.key} />
          ))}
        </Workbook.Sheet>
      </Workbook>
    );
  };

  renderChildTable = row => {
    return (
      <DenseTable
        columns={row.child.columns}
        data={row.child.data}
        config={{
          minRows: 10,
          evenRowClass: 'table-even',
          oddRowClass: 'table-odd'
        }}
      ></DenseTable>
    );
  };

  getConfiguration = (widgetconfig) => {
    let configuration = JSON.parse(
      JSON.stringify(widgetconfig.configuration)
    );
    configuration = camelcaseKeys(JSON.parse(configuration));
    return configuration;
  }

  getOnDemandData = async (dataUrl, startDate, endDate, marketName, key) => {
    return new Promise(function (resolve, reject) {
      const arg = [{ key: 'startDate', value: startDate },
      { key: 'endDate', value: endDate },
      { key: 'key', value: key },
      { key: 'marketName', value: marketName }
      ];
      apiBatchRequest([{
        url: createApiUrl(buildWidgetUrlWithParameter(dataUrl, arg)),
        // postBody: [],
        key: 'response'
      }]).then(({ response }) => {
        return resolve(response);
      }).catch(() => {
        return resolve([]);
      });
    });
  }

  render() {
    const {
      openMenu,
      anchorEl,
      openViewDetailsPanel,
      selectedTabvalue,
      ignoreColumns
    } = this.state;
    const { widgetconfig } = this.props;
    let { responseData } = this.state;
    let layoutdata = (((store.getState() || {}).localCache || {}).cachedData || []).find(x => x.key === widgetconfig.widgetId)?.data;
    const config = (((store.getState() || {}).localCache || {}).cachedData || [])
      .find(x => x.key === widgetconfig.widgetId + 'drillconfig')?.data;
    if (layoutdata && layoutdata !== '' && layoutdata.length > 0 && layoutdata !== 'undefined') {
      layoutdata = (layoutdata);
    } else {
      layoutdata = this.state.layoutComponent?.data;
    }
    let title = widgetconfig.title;
    const configuration = JSON.parse(widgetconfig.configuration);
    // if (config && config !== '' && config.length > 0 && config !== 'undefined') {
    if (config && config !== '' && config !== 'undefined') {
      // config = JSON.parse(config);
      // if (widgetconfig.widgetId === 9 && configuration.showDetailsOndemand) {
      if (configuration.showDetailsOndemand) {
        if (responseData && responseData !== undefined && responseData !== null) {
          // responseData = this.state.selectedTabvalue === 0 ? (responseData.data !== undefined ? responseData.data : responseData) : (responseData.rawData !== undefined ? responseData.rawData : responseData);
          responseData = responseData.rawData !== undefined ? responseData.rawData : responseData;
        }
      } else {
        config?.drillDownFilter?.forEach(x => {
          if (Array.isArray(x.drillDownKey)) {
            responseData = layoutdata.find(xd => xd.attributeName === x.value)?.data || [];
          } else {
            responseData = responseData?.filter(res => res[x.drillDownKey] === x.value);
          }
        });
        if (responseData === undefined || responseData.length <= 0) {
          let res = [];
          layoutdata?.forEach(x => {
            const filterData = (this.state.responseData?.filter(y => y[x.drillDownKey] === x.attributeName) || []);
            res = [...(res || []), ...(filterData || [])];
            x.data = filterData;
          });
          responseData = res;
        }
      }
    }
    //console.log(responseData, layoutdata, config);
    if (this.state?.layoutComponent?.isAutoSwitch) {
      title = configuration?.autoGenerate?.secondLevelTitle;
    }
    return (
      <>

        {widgetconfig && (
          <>
            <div
              className="dashboard-widget-wrapper"
              key={
                widgetconfig.usersWidgetMappingId +
                '_Wrapper' +
                (this.props.IsInPreviewMode && 'preview')
              }
              data-grid={{ x: 4, y: 0, w: 1, h: 2 }}
            >
              <div className="dashboard-widget-header">
                {title}

                {this.props.IsInPreviewMode !== true && widgetconfig.widgetType !== 10 && (
                  // <Tooltip title="More Option">
                  <IconButton
                    className="pull-right"
                    aria-label={'CloseIconAddWidgetPanel'}
                    size="small"
                    aria-describedby={
                      'PopOver' +
                      widgetconfig.usersWidgetMappingId +
                      '_Wrapper' +
                      (this.props.IsInPreviewMode && 'preview')
                    }
                    color="primary"
                    onClick={this.handleClick}
                    style={{ cursor: 'pointer' }}
                  >
                    <MoreVertOutlined
                      className="white-button"
                      fontSize="small"
                      size="small"
                    />
                  </IconButton>
                  // </Tooltip>
                )}
              </div>

              {responseData
                ? (
                  <div
                    className="dashboard-widget-data-contaier"
                    key={
                      widgetconfig.usersWidgetMappingId +
                      '_Container' +
                      (this.props.IsInPreviewMode && 'preview')
                    }
                  // onDragStart={e => {
                  //   e.preventDefault();
                  //   e.stopPropagation();
                  // }}
                  >
                    {' '}
                    {(this.state.layoutComponent || {}).component || (
                      <Skeleton
                        animation="wave"
                        variant="rect"
                        width={'100%'}
                        height={'90%'}
                      />
                    )}
                  </div>
                )
                : (
                  // this.getWidgetLayout(widgetconfig, responseData)
                  <Skeleton
                    animation="wave"
                    variant="rect"
                    width={'100%'}
                    height={'90%'}
                  />
                )}
            </div>
            {openMenu && (
              <Popover
                id={
                  'PopOver' +
                  widgetconfig.usersWidgetMappingId +
                  '_Wrapper' +
                  (this.props.IsInPreviewMode && 'preview')
                }
                open={openMenu}
                anchorEl={anchorEl}
                onClose={this.handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right'
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right'
                }}
              >
                <List
                  component="nav"
                  aria-label="mailbox folders"
                  className="widgetMenu"
                >

                  {/* <>
                      <ListItem
                        button
                        disabled={!widgetconfig.isConfigurable}
                        onClick={() => {
                          this.handleClose();
                          this.props.OpenWidgetConfigurationPanel(
                            { ...widgetconfig },
                            responseData[0]
                          );
                        }}
                      >
                        <ListItemIcon>
                          <Settings fontSize="small" />
                        </ListItemIcon>
                        <ListItemText fontSize="small" primary="Configure" />
                      </ListItem>
                      <Divider />
                    </> */}

                  <ListItem
                    divider
                    button
                    onClick={() => {
                      this.handleClose();
                      this.viewData(responseData, widgetconfig);
                    }}
                  >
                    <ListItemIcon>
                      {' '}
                      <ViewIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="View Data" />
                  </ListItem>

                  {/* <Divider /> */}
                  {responseData && this.DownloadData(responseData, widgetconfig)}
                  {/* {responseData && this.DownloadOnDemandData(responseData, widgetconfig)} */}
                  {/* <ListItem divider>
                                <CSVLink className="csvlink" data={this.getDownloadData(responseData, widgetconfig)}
                                    filename={widgetconfig.Title + " data.csv"}><ListItemIcon> <DownloadIcon fontSize="small" /></ListItemIcon>
                                    <ListItemText primary="Download Data" /></CSVLink>
                            </ListItem> */}
                  {/* <ListItem
                    button
                    disabled={!widgetconfig.isConfigurable}
                    onClick={() => {
                      this.handleClose();
                      const cloneconfig = { ...widgetconfig };
                      cloneconfig.usersWidgetMappingId = 0;
                      cloneconfig.title = 'Copy of ' + cloneconfig.title;
                      cloneconfig.isClone = true;
                      this.handleClose();
                      this.props.OpenWidgetConfigurationPanel(
                        cloneconfig,
                        responseData[0]
                      );
                    }}
                  >
                    <ListItemIcon>
                      {' '}
                      <CloneIcon fontSize="small" />{' '}
                    </ListItemIcon>
                    <ListItemText primary="Clone this widget" />
                  </ListItem>
                  <Divider light />
                  <ListItem
                    button
                    onClick={() => {
                      this.handleClose();
                      this.props.onRemoveWidgetMapping(
                        widgetconfig.usersWidgetMappingId
                      );
                    }}
                  >
                    <ListItemIcon>
                      {' '}
                      <DeleteIcon fontSize="small" />{' '}
                    </ListItemIcon>
                    <ListItemText primary="Remove Widget" />
                  </ListItem> */}
                </List>

                <Typography></Typography>
              </Popover>
            )}
            {openViewDetailsPanel && (
              <Dialog
                fullScreen={false}
                open={openViewDetailsPanel}
                maxWidth="lg"
                onClose={() => this.viewData()}
                aria-labelledby="responsive-dialog-title"
                PaperComponent={PaperComponent}
              >
                <DialogTitle id="responsive-dialog-title">
                  {(this.state?.layoutComponent?.isAutoSwitch
                    ? configuration?.autoGenerate?.secondLevelTitle
                    : widgetconfig.title) + ' (Data)'}
                  <IconButton
                    edge="end"
                    color="inherit"
                    className={'pull-right'}
                    onClick={() => {
                      this.viewData();
                    }}
                    aria-label="close"
                  >
                    <IoMdCloseCircleOutline />
                  </IconButton>
                </DialogTitle>
                <DialogContent>
                  <AppBar position="static" color="default">
                    <Tabs
                      value={selectedTabvalue}
                      onChange={this.handleTabChange}
                      indicatorColor="primary"
                      textColor="primary"
                      variant="fullWidth"
                      aria-label="full width tabs example"
                    >
                      <Tab label="Summary Data" {...this.tabProps(0)} />
                      <Tab label="Details" {...this.tabProps(1)} />
                    </Tabs>
                  </AppBar>

                  <TabPanel value={selectedTabvalue} index={0}>
                    {(responseData || []).length > 0 ||
                      (widgetconfig.isForPerformance &&
                        responseData.rawData.length > 0)
                      ? (
                        responseData && (
                          <DenseTable
                            {...GetPropsForData(
                              'summary',
                              responseData,
                              widgetconfig,
                              layoutdata
                            )}
                            ignoreColumns={ignoreColumns}
                            tableConfig={this.state.tableConfig}
                          ></DenseTable>
                        )
                      )
                      : (
                        <div style={{ width: '100%', textAlign: 'center' }}>
                          Data Not Available
                        </div>
                      )}
                  </TabPanel>
                  <TabPanel value={selectedTabvalue} index={1}>
                    {(responseData || []).length > 0 ||
                      (widgetconfig.isForPerformance &&
                        responseData.rawData.length > 0)
                      ? (
                        responseData && (
                          <DenseTable
                            {...GetPropsForData(
                              'details',
                              widgetconfig.isForPerformance === true
                                ? responseData.rawData || []
                                : widgetconfig.isConfigurable === false &&
                                  widgetconfig.widgetType !== 10
                                  ? this.state.rawData || []
                                  : responseData || [],
                              widgetconfig,
                              layoutdata
                            )}
                            ignoreColumns={ignoreColumns}
                            tableConfig={this.state.tableConfig}
                          ></DenseTable>
                        )
                      )
                      : (
                        <div style={{ width: '100%', textAlign: 'center' }}>
                          Data Not Available
                        </div>
                      )}
                  </TabPanel>
                </DialogContent>
              </Dialog>
            )}
          </>
        )}

      </>
    );
  }
}
// export default RenderLayout;
export default withRouter(RenderLayout);
